<template>
    <div class="pt-user-package-type"  v-if="packageVisible">
        <ul v-for="(pack, index) in userPackages" :key="index">
            <li
                class="patsnap-biz-user-banner__item-endtime"
            >
                {{ t('PtUserBanner.endTime', {date : pack.end_at}) }}
            </li>
            <li
                class="patsnap-biz-user-banner__item-type"
            >
                <span
                    class="patsnap-biz-user-banner__item-type-tag"
                    :class="`patsnap-biz-user-banner__item-type-tag-${pack.eureka_package}`"
                >
                    {{ t(`PtUserBanner.${pack.eureka_package}`) }}
                </span>
                <a :href="getLinkHref(pack.eureka_package)" target="_blank" v-if="isShowUpgradeVision(pack.eureka_package)" class="text-blue-500 ml-1 cursor-pointer hover:no-underline" :title="$t('noPermission.try')">
                    <span>
                        {{ t('noPermission.try') }}
                    </span>
                </a>
            </li>

        </ul>
    </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';
import _ from 'lodash';
import { CommonApis } from '@eureka/services/src/apis/common.api'
import { EUserPackage, type IPackageType } from '@eureka/services/src/apis/common.api.types';
import { useI18n } from 'vue-i18n';
import { cn, tw, en, jp } from './locales';

const userPackages = ref<IPackageType[]>([]);

const packageVisible = computed(() => {
    return !_.isEmpty(userPackages.value)
})

const { t } = useI18n({
    messages: {
        cn, tw, en, jp,
    },
});

function isShowUpgradeVision(value: EUserPackage) {
    return [
        EUserPackage.GENERAL_FREEMIUM,
        EUserPackage.GENERAL_TRIAL,
        EUserPackage.MATERIAL_TRIAL
    ].includes(value)
}

function getLinkHref(value: EUserPackage) {
    const number = value === EUserPackage.MATERIAL_TRIAL ? 2 : 1;
    return `/user-setting/package?open_update_auto=${number}&source_type=account_upgrade`
}

onMounted(async() => {
    userPackages.value = await CommonApis.getUserPackageType()
});
</script>

<style lang="scss">
.patsnap-biz-user-banner__item-endtime {
    @apply text-grey-90;
    margin-top: 16px;
}
.patsnap-biz-user-banner__item-type {
    margin-top: 8px;
    &-tag {
        @apply text-eureka-500 bg-eureka-75;
        font-size: 14px;
        line-height: 16px;
        padding: 2px 4px;
        border-radius: 4px;
        &-GENERAL_FREEMIUM {
            @apply bg-gray-30 text-gray-450;
        }
    }
}
</style>
